import { useSpaceIDFromPath } from '@/data/space/hooks';
import { useGetProductCollectionQuery, useGetSpaceQuery } from '@/store';
import { Text } from '@typedream/ui';
import LoadingSmall from '../LoadingSmall';

export function ProductsInboxPreview() {
  const spaceID = useSpaceIDFromPath();
  const { data: space, isLoading: spaceLoading } = useGetSpaceQuery([spaceID]);
  const { data: productCollection, isLoading: productCollectionLoading } =
    useGetProductCollectionQuery([spaceID]);

  return (
    <div className="flex flex-col gap-4">
      <Text size="xs">Inbox Preview</Text>
      <div
        className="relative flex gap-2 items-start w-full p-4 rounded-lg bg-neutral-25 dark:bg-neutral-800 overflow-hidden"
        style={{ boxShadow: 'var(--shadow-modal)' }}
      >
        {spaceLoading || productCollectionLoading ? (
          <div className="absolute top-0 bottom-0 left-0 right-0 bg-neutral-25 flex items-center justify-center">
            <LoadingSmall loading />
          </div>
        ) : null}
        <div className="rounded-full h-[11px] w-[11px] bg-[#619CFF] my-1" />
        <div className="flex flex-col gap-2" style={{ width: 'calc(100% - 19px)' }}>
          <div className="flex gap-4 justify-between w-full">
            <Text as="p" size="sm" weight="bold">
              {productCollection?.field?.mailing?.sender_name || space?.name || ''}
            </Text>
            <Text size="sm" weight="medium" className="text-secondary">
              9:30AM
            </Text>
          </div>
          <Text size="sm" weight="medium">
            You got Notion Icon Pack!
          </Text>
          <Text
            size="sm"
            className="whitespace-nowrap overflow-hidden w-full text-ellipsis text-secondary"
          >
            Thank you for your purchase for Notion Icon Pack. You can view the content from
          </Text>
        </div>
      </div>
    </div>
  );
}
